<template>
  <div class="bzbd-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.orderType" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="150"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.delname && scope.row.delname.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.delname }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderType===0">正单</span>
                      <span v-if="scope.row.orderType===1">客改单</span>
                      <span v-if="scope.row.orderType===2">增补单</span>
                      <span v-if="scope.row.orderType===3">色板单</span>
                      <span v-if="scope.row.orderType===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分派工厂"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.factoryname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="部件数量"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.comnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包装状态"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag size="mini" :disable-transitions="true" v-if="scope.row.comnum===scope.row.packednum">包装完整</el-tag>
                      <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.comnum!==scope.row.packednum">缺件 {{scope.row.comnum-scope.row.packednum}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最近打包时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.packnum>0">{{scope.row.time}}</span>
                      <span v-if="scope.row.packnum===0" style="color:#99a9bf">未打包</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包装数量"
                    width="150"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.packnum}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="订单包装列表"
      :visible.sync="editVisible"
      width="60%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editForm" :inline="true" :model="editForm" :rules="editRules" label-width="80px">
        <el-form-item label="生产单号" prop="produnum">
          <el-input v-model="editForm.produnum" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="包装类型" prop="ptid">
          <el-select v-model="editForm.ptid">
            <el-option
              v-for="item in packtypeList"
              v-if="item.dBrand===0||group.dBrand===0||group.dBrand===item.dBrand"
              :key="item.dPtid"
              :label="item.dName"
              :value="item.dPtid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="allPrint" icon="el-icon-document">整单打印</el-button>
        </el-form-item>
        <br>
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="editForm.packnum" maxlength="14" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="包号" prop="xuhao">
          <el-input type="number" v-model="editForm.xuhao" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchPack" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" @click="batchPrint" icon="el-icon-printer" plain>批量打印</el-button>
        </el-form-item>
      </el-form>
      <div style="height: 400px;width: 100%" v-loading="packloading">
        <pl-table
          height="400px"
          :key="tableKey"
          :datas="packTableData"
          :data="packTableData"
          use-virtual
          :pagination-show="false"
          @selection-change="handleSelectionChange"
          size="small"
          :row-height="45">
          <pl-table-column type="selection" align="center" width="50"></pl-table-column>
          <pl-table-column prop="packnum" :resizable="false" align="center" label="包标签号" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="xuhao" :resizable="false" align="center" label="包号" show-overflow-tooltip width="90"></pl-table-column>
          <pl-table-column prop="username" :resizable="false" align="center" label="打包人" show-overflow-tooltip width="100"></pl-table-column>
          <pl-table-column prop="time" :resizable="false" align="center" label="打包时间" show-overflow-tooltip min-width="130"></pl-table-column>
          <pl-table-column prop="num" :resizable="false" align="center" label="部件数量" show-overflow-tooltip width="90"></pl-table-column>
          <pl-table-column label="操作" :resizable="false" width="100" align="center">
            <template slot-scope="scope">
              <el-button size="mini" icon="el-icon-printer" @click="print(scope.row)">打印</el-button>
            </template>
          </pl-table-column>
        </pl-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getErpPackList,
  getErpPacktypelist,
  getErpOrderPackList,
  ErpPackReprint,
  exportPackMendList, getGroupInfoByUser
} from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'bzbd',
  computed: {
    user: getUser
  },
  data() {
    return {
      exportLoading: false,
      fullscreenLoading: false,
      searchForm: {
        search: '',
        orderType: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      group: {
        dBrand: 1
      },
      packtypeList: [],
      editForm: {
        ptid: null,
        packnum: '',
        xuhao: '',
        orderid: '',
        produnum: ''
      },
      editRules: {
        ptid: [{ required: true, message: '请选择包装类型', trigger: 'change' }],
        produnum: [{ required: true, message: '请选择订单', trigger: 'change' }]
      },
      tableKey: '',
      multipleSelection: [],
      packTableData: [],
      packloading: false
    }
  },
  created() {
    this.getData()
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    getErpPacktypelist().then(response => {
      this.packtypeList = response.data
    }).catch(() => {})
  },
  methods: {
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          content: this.searchForm.search,
          groupid: this.user.dGroupid,
          userid: this.user.dUserid,
          role: this.user.role,
          orderType: this.searchForm.orderType,
          tableName: '包装补打'
        }
        exportPackMendList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        orderType: this.searchForm.orderType
      }
      getErpPackList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    openDetails(row) {
      this.editForm.orderid = row.orderid
      this.editForm.produnum = row.produnum.indexOf('SZ') >= 0 ? row.ordernum : row.produnum
      this.editForm.packnum = ''
      this.editForm.xuhao = ''
      this.editForm.ptid = null
      this.editVisible = true
      this.searchPack()
    },
    searchPack() {
      this.packTableData = []
      this.multipleSelection = []
      this.packloading = true
      const data = {
        orderid: this.editForm.orderid,
        packnum: this.editForm.packnum,
        xuhao: this.editForm.xuhao
      }
      getErpOrderPackList(data).then(response => {
        this.tableKey = new Date().getTime()
        this.packTableData = response.data
        this.packloading = false
      }).catch(() => {
        this.packloading = false
      })
    },
    allPrint() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        this.subPrint(2,'')
      }
    },
    print(row) {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (row.packid !== null && row.packid !== '' && row.packid !== undefined) {
          this.subPrint(1, row.packid)
        } else {
          this.$message.error('包标签号获取失败')
        }
      }
    },
    batchPrint() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (this.multipleSelection.length > 0) {
          let ids = []
          for (let m of this.multipleSelection) {
            if (m.packid !== null && m.packid !== '' && m.packid !== undefined) {
              ids.push(m.packid)
            }
          }
          if (ids.length > 0) {
            this.subPrint(1, ids.join(','))
          } else {
            this.$message.error('未选中要打印的包装')
          }
        } else {
          this.$message.error('未选中要打印的包装')
        }
      }
    },
    subPrint(n, ids) {
      this.$refs.editForm.validateField('ptid', errMsg => {
        if (!errMsg) {
          this.fullscreenLoading = true
          const data = {
            type: n,
            orderid: this.editForm.orderid,
            ids: ids,
            ptid: this.editForm.ptid,
            groupid: this.user.dGroupid
          }
          ErpPackReprint(data).then(response => {
            this.fullscreenLoading = false
            this.$message({
              message: '包装补打成功',
              type: 'success'
            })
            let LODOP = getLodop()
            LODOP.PRINT_INIT('包装打印')
            LODOP.SET_PRINT_PAGESIZE(1, '100mm', '100mm', '')
            LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
            for (let pack of response.data) {
              LODOP.NewPageA()
              LODOP.ADD_PRINT_HTM('2mm', '4mm', '100%', '100%', pack)
            }
            LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 500)
            LODOP.PREVIEW()
            // LODOP.PRINT()
          }).catch(() => {
            this.fullscreenLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bzbd-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
